import { render } from "./DeliveryStagesSection.vue?vue&type=template&id=2530dfaa&scoped=true"
import script from "./DeliveryStagesSection.vue?vue&type=script&lang=js"
export * from "./DeliveryStagesSection.vue?vue&type=script&lang=js"

import "./DeliveryStagesSection.vue?vue&type=style&index=0&id=2530dfaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2530dfaa"]])

export default __exports__